import React from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { orange, brown, red } from "@mui/material/colors";
import "@fontsource/merriweather";
import "@fontsource/ultra";
import "@fontsource/roboto";
import Image from "mui-image";
import menuSp from "../../../Assets/wed-special.png";

import stampRed from "../../../Assets/stamp-red.png";

import topBbqStamp from "../../../Assets/top-bbg-stamp.png";

const HomeDetails = () => {
  const isHolidaySeason = () => {
    const now = new Date();
    const year = now.getFullYear();

    // Calculate the date of Thanksgiving (fourth Thursday of November)
    const getThanksgivingDate = (year) => {
      const novemberFirst = new Date(year, 10, 1); // November 1st
      const dayOfWeek = novemberFirst.getDay(); // 0 (Sun) to 6 (Sat)
      const firstThursday = 1 + ((4 - dayOfWeek + 7) % 7);
      const thanksgivingDate = new Date(year, 10, firstThursday + 21); // Add 3 weeks
      return thanksgivingDate;
    };

    const thanksgivingDate = getThanksgivingDate(year);
    const holidaySeasonStart = thanksgivingDate;
    const holidaySeasonEnd = new Date(year + 1, 0, 1); // January 1st of next year

    return now >= holidaySeasonStart && now < holidaySeasonEnd;
  };

  // Function to get the current season or "HOLIDAY" if during the holiday season
  const getSeason = () => {
    if (isHolidaySeason()) {
      return "HOLIDAY";
    } else {
      const month = new Date().getMonth(); // 0 (Jan) to 11 (Dec)
      if (month >= 2 && month <= 4) {
        return "SPRING";
      } else if (month >= 5 && month <= 7) {
        return "SUMMER";
      } else if (month >= 8 && month <= 10) {
        return "AUTUMN";
      } else {
        return "WINTER";
      }
    }
  };

  const currentSeason = getSeason(); // Get the current season

  return (
    <Box>
      <Box
        sx={{
          py: 3,

          display: "flex",

          flexDirection: "column",

          alignItems: "center",

          justifyContent: "center",

          textAlign: "center",
        }}
      >
        <Card
          sx={{
            width: { md: "95%", lg: "60%" },
          }}
        >
          <CardMedia
            component="img"
            sx={{
              height: { xs: "auto", md: "auto" },

              objectFit: { xs: "fill", md: "contain" },

              border: "5px solid #ffff",

              borderRadius: "10px",
            }}
            image={menuSp}
          />
        </Card>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" color="text.secondary">
            Enjoy Our Special Holiday Meal
          </Typography>
          <Button
            href="https://drive.google.com/file/d/1Zj0NOS4gaU0aaWX7KfTosxYVin69BNHa/view?usp=drive_link"
            sx={{
              textAlign: "center",
              width: "50%",
            }}
            variant="outlined"
            size="large"
            color="primary"
          >
            Download Menu
          </Button>
        </CardContent>
      </Box>
      <Container
        maxWidth="100%"
        sx={{
          border: "0 2px solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "50px",
          textAlign: "center",
          alignItems: "center",
          padding: "30px 0",
          backgroundColor: orange[800],
        }}
      >
        <Typography variant="h3">
          Get Your BBQ Order Here: <br />
          682-262-7553
        </Typography>
        <Typography
          fontFamily="Ultra"
          variant="h3"
          sx={{ padding: "0 10%", lineHeight: "" }}
        >
          {currentSeason} SEASON
          <br /> Is Here..! <br />
          Let's BBQ!!
        </Typography>

        {/* <Typography fontFamily="Ultra" sx={{ padding: "0 30%" }} variant="h5">
          Fine Authentic Texas BBQ Holiday Meals are available with 48hrs
          advance notice.
        </Typography> */}
        <Button
          size="large"
          color="inherit"
          sx={{ width: "30%" }}
          variant="outlined"
          href="/menu"
        >
          View Menu
        </Button>
      </Container>
      <Container
        maxWidth="100%"
        sx={{
          border: "0 2px solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "50px",
          textAlign: "center",
          alignItems: "center",
          padding: 3,
          backgroundColor: brown[800],
        }}
      >
        <Typography fontFamily="Ultra" variant="h3">
          <Image
            duration="0"
            src={stampRed}
            style={{ height: "250px", width: "250px" }}
          />
          Authentic Premium Texas BBQ <br /> True Texas Flavor
        </Typography>
        <Typography fontFamily="roboto" sx={{ padding: "0 20%" }} variant="p">
          Our Premium BBQ is delish tasting and crafted with love. We use
          premium meats and fine herbs and spices. Our meats are slowed cooked
          to perfection in-house over natural Texas hickory wood.
        </Typography>
        <Typography fontFamily="roboto" sx={{ padding: "0 20%" }} variant="p">
          All of our catering comes with choices of sides made by our team of
          chefs. We offer coleslaw, homestyle potato salad, mashed potatoes,
          green beans, mac n cheese, stuff baked potatoes and beans. Our
          desserts are yummy as well with various pies selections and more.
          Catering can be picked up or delivered to your Wedding location.
          Holler Valerie and get a quote.
        </Typography>
      </Container>
      <Container
        maxWidth="100%"
        sx={{
          border: "0 2px solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "50px",
          textAlign: "center",
          alignItems: "center",
          padding: "30px 0",
          backgroundColor: red[800],
        }}
      >
        <Typography fontFamily="Ultra" variant="h3">
          <Image
            duration="0"
            src={topBbqStamp}
            style={{ height: "280px", width: "300pxx" }}
          />
          Slow Smoked & <br /> Mouth Watering Delicious BBQ{" "}
        </Typography>
        <Typography fontFamily="Ultra" sx={{ padding: "0 10%" }} variant="h5">
          Congratulations To The Bride (Cowgirl) and Groom (Cowboy)!
        </Typography>
        <Typography fontFamily="roboto" sx={{ padding: "0 20%" }} variant="p">
          Our wedding guests will enjoy Authentic Texas BBQ made by our
          co-Founder and Award-winning PitMaster, Robert Austin and co-Founder
          Valerie Austin. The Austin Family has catered Texas for over 30yrs.
          Robert and Valerie Austin team are from fine dining to pitmaster BBQ
          veterans. They have been in the restaurant industry for over 30yrs and
          serving the finest premium BBQ. For the LOVE of BBQ, their passion for
          fine BBQ foods and great service shows in their Texas BBQ and catering
          services. Get A Quote and start enjoying!! YEHAW!
        </Typography>
        <Button
          size="large"
          color="inherit"
          sx={{
            width: "25%",
          }}
          variant="outlined"
          href="/menu"
        >
          View Menu
        </Button>
      </Container>
    </Box>
  );
};

export default HomeDetails;
